export default node => ({
	type: 'ARTICLE_BUY_BUTTON',
	name: 'Buy button',
	allowedSections: ['article', 'main'],
	disallowedChildren: [],
	category: 'Article',
	props: [{
		name: 'buttonText',
		inputType: 'text',
		label: 'Text',
		default: 'Add to cart'
	}, {
		name: 'goToCheckout',
		inputType: 'checkbox',
		label: 'Go to checkout after add',
		default: false
	}],
	hiddenProps: [{
		label: 'Out of stock settings',
		props: [{
			name: 'outOfStockButtonText',
			inputType: 'text',
			label: 'Text',
			default: 'Out of stock'
		}, {
			name: 'outOfStockBackgroundColor',
			inputType: 'color',
			label: 'Button background color',
			default: '#777'
		}, {
			name: 'outOfStockColor',
			inputType: 'color',
			label: 'Text color',
			default: '#fff'
		}, {
			name: 'hideOutOfStockButton',
			inputType: 'checkbox',
			label: 'Hide button',
			default: false
		}, {
			name: 'outOfStockMessage',
			inputType: 'text',
			label: 'Out of stock message',
			default: ''
		}]
	}, {
		label: 'Custom ID',
		props: [{
			name: 'itemId',
			inputType: 'text',
			label: 'ID'
		}, node && node.props && node.props.itemId && {
			label: 'Type',
			name: 'itemType',
			inputType: 'select',
			default: 'article',
			values: [{
				label: 'Article',
				value: 'article'
			}, {
				label: 'Subscription',
				value: 'subscription'
			}]
		}].concat(node && node.props && node.props.itemId && node.props.itemType !== 'subscription' && [{
			name: 'attr1_id',
			inputType: 'text',
			label: 'Attribute 1 ID'
		}, {
			name: 'attr2_id',
			inputType: 'text',
			label: 'Attribute 2 ID'
		}, {
			name: 'attr3_id',
			inputType: 'text',
			label: 'Attribute 3 ID'
		}]).filter(Boolean)
	}, {
		label: 'Advanced settings',
		props: [{
			name: 'class',
			inputType: 'text',
			label: 'CSS-class',
			default: ''
		}]
	}]
});
